module.exports = "<div [style.padding-left.px]=\"level * 20 + 31\" class=\"select__opt selectable\" (click)=\"toggleSelectGroup()\"><input type=\"checkbox\" class=\"select__opt-checkbox\" [checked]=\"groupSelected()\" [indeterminate]=\"groupPartiallySelected()\"><div class=\"select__opt-label\">{{ group.label }}</div></div>"


//////////////////
// WEBPACK FOOTER
// ./app/common/forms/multi-select-group.component.html
// module id = 1117
// module chunks = 4